







































































































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatNumber, formatPercent, formatHours } from '@/lib/reportFormatters';

@Component({ name: 'ActivityReports' })
export default class ActivityReports extends GiganautVue {

  leaderboardHeaders = [
    { text: 'User', value: 'userName' },
    { text: 'Total', value: 'totalActivities', align: 'end' },
    { text: 'Calls Made', value: 'callsMade', align: 'end' },
    { text: 'Connected', value: 'callsConnected', align: 'end' },
    { text: 'Emails', value: 'emailsSent', align: 'end' },
    { text: 'Meetings', value: 'meetingsHeld', align: 'end' },
    { text: 'Tasks', value: 'tasksCompleted', align: 'end' },
  ];

  mixHeaders = [
    { text: 'User', value: 'userName' },
    { text: 'Calls', value: 'calls', align: 'end' },
    { text: 'Emails', value: 'emails', align: 'end' },
    { text: 'Meetings', value: 'meetings', align: 'end' },
    { text: 'Tasks', value: 'tasks', align: 'end' },
    { text: 'Notes', value: 'notes', align: 'end' },
    { text: 'Total', value: 'total', align: 'end' },
  ];

  callHeaders = [
    { text: 'User', value: 'userName' },
    { text: 'Total Calls', value: 'totalCalls', align: 'end' },
    { text: 'Connected', value: 'connected', align: 'end' },
    { text: 'Connect Rate', value: 'connectRate', align: 'end' },
  ];

  priorityHeaders = [
    { text: 'Priority', value: 'label' },
    { text: 'Count', value: 'value', align: 'end' },
  ];

  get activityLeaderboard() { return ManagementReportsModule.activityLeaderboard; }
  get activityMix() { return ManagementReportsModule.activityMix; }
  get callEffectiveness() { return ManagementReportsModule.callEffectiveness; }
  get taskManagement() { return ManagementReportsModule.taskManagement; }

  fmtNum(v: number) { return formatNumber(v); }
  fmtPct(v: number) { return formatPercent(v); }
  fmtHours(v: number) { return formatHours(v); }
}
